/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import Vue from 'vue';
import * as types from "./types";

const mutations = {
  [types.SAVE_PLACEMENT_IMAGE](state, { imageData, canvasJSON }) {
    const placementViewOrder = this.getters["ugc/tempData/getPlacementViewOrder"];
    const activeComponent = this.getters["ugc/tempData/getActiveUGCComponent"];

    if (!state.buffers[activeComponent]) {
      state.buffers = { ...state.buffers, [activeComponent]: [] };
    }
    state.buffers[activeComponent][placementViewOrder] = canvasJSON;

    if (!state.responses[activeComponent]) {
      state.responses = { ...state.responses, [activeComponent]: [] };
    }

    state.responses[activeComponent][placementViewOrder] = imageData;
  },
  [types.CLEAR_PLACEMENTS](state) {
    state.responses = {};
  },
  [types.CLEAR_COMPONENT_BUFFER](state, component) {
    Vue.delete(state.buffers, component);
  },
  [types.CLEAR_COMPONENT_PLACEMENTS](state, component) {
    Vue.delete(state.responses, component);
  },
  [types.CLEAR_ALL](state) {
    state.buffers = {};
    state.responses = {};
  },
  [types.SET_BUFFER](state, { index, value }) {
    const activeComponent = this.getters["ugc/tempData/getActiveUGCComponent"];
    state.buffers[activeComponent][index] = value;
  },
  [types.SET_COMPONENT_PLACEMENTS](state, { index, value }) {
    const activeComponent = this.getters["ugc/tempData/getActiveUGCComponent"];
    if (!state.responses[activeComponent]) {
      state.responses = { ...state.responses, [activeComponent]: [] };
    }
    state.responses[activeComponent][index] = value;
  }
};

export default mutations;
